import {
  FETCH_ORDER_BY_ORDER_NUMBER,
  FETCH_ORDER_BY_ORDER_NUMBER_FAILURE,
  FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS,
  RESET_TRACKED_ORDER,
} from "./trackOrderTypes";

export const fetchOrderByOrderNumber = ({ orderNumber, lang }) => ({
  type: FETCH_ORDER_BY_ORDER_NUMBER,
  payload: { orderNumber, lang },
});

export const fetchOrderByOrderNumberSuccess = ({ order }) => ({
  type: FETCH_ORDER_BY_ORDER_NUMBER_SUCCESS,
  payload: order,
});

export const fetchOrderByOrderNumberFailure = (error) => ({
  type: FETCH_ORDER_BY_ORDER_NUMBER_FAILURE,
  payload: error,
});

export const resetTrackedOrder = () => ({
  type: RESET_TRACKED_ORDER,
});
